import React, { createContext, useContext } from 'react'
import { Permission, PERMISSIONS } from 'services/auth/permissions'
import { useSelector } from 'react-redux'
import { selectUserPermissions } from './auth'

interface PermissionContextType {
  hasPermission: (p?: Permission) => boolean
}

const PermissionContext = createContext<PermissionContextType>({
  hasPermission: () => false,
})

export const PermissionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const permissions = useSelector(selectUserPermissions)

  const hasPermission = React.useCallback(
    (p?: Permission) => {
      if (!p || !permissions) return true // TODO: remove this, temporary fix
      if (permissions?.includes(PERMISSIONS.CUSTOM.ADMIN)) {
        return true
      }
      return permissions?.includes(p) || false
    },
    [permissions],
  )

  const contextValue = React.useMemo(() => ({ hasPermission }), [hasPermission])

  return <PermissionContext.Provider value={contextValue}>{children}</PermissionContext.Provider>
}

export const usePermission = () => useContext(PermissionContext)
